export default __webpack_public_path__ + "static/media/markup.df6f1d57.png";